const styles = (theme) => ({
  root: {
    '& .CardIcon': {
      color: theme.palette.custom.maintenance,
      backgroundColor: theme.palette.background.lighter,
    },
  },
  title: {
    paddingBottom: theme.spacing.unit * 2,
    borderBottom: `1px solid ${theme.palette.underline.dark}`,
  },
  gridColumn: {
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing.unit * 1.5,
    },
  },
});

export default styles;
